"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_PATTERN_SIZE = exports.chartTimepointPattern = exports.CHART_TIMEPOINT_PATTERNS = exports.CHART_BAR_OUTLINE = exports.zToGpfitPoints = exports.GPFIT_POINT_COLORS = exports.gpfitPointColor = exports.GPFIT_GRADIENT_STOPS = void 0;
exports.gpfitGradientColor = gpfitGradientColor;
exports.chartValueColor = chartValueColor;
exports.chartPatternMarkup = chartPatternMarkup;
exports.chartPatternDef = chartPatternDef;
/** 81-stop gradient, 0 % = 1 point (dark red) … 100 % = 9 points (cyan). */
exports.GPFIT_GRADIENT_STOPS = [
    [0, "#CC0000"],
    [1.25, "#D60000"],
    [2.5, "#E00000"],
    [3.75, "#EA0000"],
    [5, "#F40000"],
    [6.25, "#FF0000"],
    [7.5, "#FF1F0A"],
    [8.75, "#FF3D14"],
    [10, "#FF5C1F"],
    [11.25, "#FF7A29"],
    [12.5, "#FF9933"],
    [13.75, "#FFA329"],
    [15, "#FFAD1F"],
    [16.25, "#FFB814"],
    [17.5, "#FFC20A"],
    [18.75, "#FFCC00"],
    [20, "#FED201"],
    [21.25, "#FED703"],
    [22.5, "#FDDD03"],
    [23.75, "#FDE403"],
    [25, "#FCEA04"],
    [26.25, "#FDF004"],
    [27.5, "#FDF504"],
    [28.75, "#FEF804"],
    [30, "#FEFB01"],
    [31.25, "#FFFF00"],
    [32.5, "#FFFF14"],
    [33.75, "#FFFF29"],
    [35, "#FFFF3D"],
    [36.25, "#FFFF52"],
    [37.5, "#FFFF66"],
    [38.75, "#F5FF66"],
    [40, "#EBFF66"],
    [41.25, "#E0FF66"],
    [42.5, "#D6FF66"],
    [43.75, "#CCFF66"],
    [45, "#C2FF66"],
    [46.25, "#B8FF66"],
    [47.5, "#ADFF66"],
    [48.75, "#A3FF66"],
    [50, "#99FF66"],
    [51.25, "#8FFF60"],
    [52.5, "#85FF59"],
    [53.75, "#7BFF53"],
    [55, "#70FF4C"],
    [56.25, "#66FF46"],
    [57.5, "#5CFF3F"],
    [58.75, "#52FF39"],
    [60, "#48FF32"],
    [61.25, "#3DFF2C"],
    [62.5, "#01FF05"],
    [63.75, "#01FC0B"],
    [65, "#01F912"],
    [66.25, "#00F619"],
    [67.5, "#00F320"],
    [68.75, "#00F223"],
    [70, "#00ED2C"],
    [71.25, "#00E835"],
    [72.5, "#00E33F"],
    [73.75, "#00DE48"],
    [75, "#00DA4E"],
    [76.25, "#00DE60"],
    [77.5, "#00E271"],
    [78.75, "#00E683"],
    [80, "#00EB8C"],
    [81.25, "#00FF96"],
    [82.5, "#00FFA0"],
    [83.75, "#00FFAA"],
    [85, "#00FFB4"],
    [86.25, "#00FFBE"],
    [87.5, "#00FFC8"],
    [88.75, "#00FFD0"],
    [90, "#00FFD7"],
    [91.25, "#00FFDF"],
    [92.5, "#00FFE2"],
    [93.75, "#00FFE6"],
    [95, "#00FFEB"],
    [96.25, "#00FFF0"],
    [97.5, "#00FFF5"],
    [98.75, "#00FFFA"],
    [100, "#00FFFF"],
];
const hex2 = (n) => Math.round(n).toString(16).padStart(2, "0");
function interpolate(c1, c2, f) {
    const ch = (c, i) => parseInt(c.slice(i, i + 2), 16);
    const mix = (i) => ch(c1, i) + (ch(c2, i) - ch(c1, i)) * f;
    return `#${hex2(mix(1))}${hex2(mix(3))}${hex2(mix(5))}`;
}
/** Colour at 0..100 % of the gradient (clamped). */
function gpfitGradientColor(percentage) {
    const p = Math.max(0, Math.min(100, percentage));
    for (let i = 0; i < exports.GPFIT_GRADIENT_STOPS.length - 1; i++) {
        const [p1, c1] = exports.GPFIT_GRADIENT_STOPS[i];
        const [p2, c2] = exports.GPFIT_GRADIENT_STOPS[i + 1];
        if (p >= p1 && p <= p2)
            return interpolate(c1, c2, (p - p1) / (p2 - p1));
    }
    return exports.GPFIT_GRADIENT_STOPS[exports.GPFIT_GRADIENT_STOPS.length - 1][1];
}
/** Colour of a GPfit point value 1..9 (fractions interpolate, as on the Ergebnisblatt). */
const gpfitPointColor = (points) => gpfitGradientColor(((points - 1) / 8) * 100);
exports.gpfitPointColor = gpfitPointColor;
/** The colours of the whole points 1..9 (legend; 1 = dark red … 9 = cyan). */
exports.GPFIT_POINT_COLORS = [
    1, 2, 3, 4, 5, 6, 7, 8, 9,
].map(exports.gpfitPointColor);
/** Equivalent GPfit points of a z-value: 2·z + 5, clamped to 1..9 (STA9 rule). */
const zToGpfitPoints = (z) => Math.max(1, Math.min(9, 2 * z + 5));
exports.zToGpfitPoints = zToGpfitPoints;
/** Bar colour of a chart value (GPfit points or z) on the points scale. */
function chartValueColor(value, metric) {
    if (value === null || value === undefined || !Number.isFinite(value)) {
        return "#D1D5DB";
    }
    return (0, exports.gpfitPointColor)(metric === "z" ? (0, exports.zToGpfitPoints)(value) : value);
}
/** Outline of the coloured bars: the light colours (yellow, cyan) need it on white. */
exports.CHART_BAR_OUTLINE = "#374151";
/**
 * Hatch per timepoint, so that T1..Tn stay apart without a second colour
 * scale (the colour is the value). T1 solid, then lines/dots; T9+ repeat.
 */
exports.CHART_TIMEPOINT_PATTERNS = [
    "solid",
    "diagonal",
    "dots",
    "backDiagonal",
    "horizontal",
    "cross",
    "vertical",
    "grid",
];
const chartTimepointPattern = (key) => exports.CHART_TIMEPOINT_PATTERNS[(Math.max(1, Number(key.slice(1)) || 1) - 1) %
    exports.CHART_TIMEPOINT_PATTERNS.length];
exports.chartTimepointPattern = chartTimepointPattern;
/** Size of one pattern tile (user space units). */
exports.CHART_PATTERN_SIZE = 6;
const INK = 'stroke="#1F2937" stroke-opacity="0.7" stroke-width="1.1"';
/**
 * Inner SVG markup of one pattern tile (6×6, dark ink, transparent ground);
 * drawn over the value colour. Shared by the web charts and the PDFs.
 */
function chartPatternMarkup(pattern) {
    switch (pattern) {
        case "diagonal":
            return `<path d="M-1,1 l2,-2 M0,6 l6,-6 M5,7 l2,-2" ${INK}/>`;
        case "backDiagonal":
            return `<path d="M-1,5 l2,2 M0,0 l6,6 M5,-1 l2,2" ${INK}/>`;
        case "dots":
            return '<circle cx="3" cy="3" r="1.1" fill="#1F2937" fill-opacity="0.75"/>';
        case "horizontal":
            return `<path d="M0,3 h6" ${INK}/>`;
        case "vertical":
            return `<path d="M3,0 v6" ${INK}/>`;
        case "cross":
            return `<path d="M0,0 l6,6 M6,0 l-6,6" ${INK}/>`;
        case "grid":
            return `<path d="M0,3 h6 M3,0 v6" ${INK}/>`;
        default:
            return "";
    }
}
/** Full `<pattern>` element (PDF SVG strings). */
function chartPatternDef(id, pattern) {
    const s = exports.CHART_PATTERN_SIZE;
    return `<pattern id="${id}" width="${s}" height="${s}" patternUnits="userSpaceOnUse">${chartPatternMarkup(pattern)}</pattern>`;
}
